import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const NotFound = () => {
    return (
        <>
            <Helmet>
                <title>Page Not Found | Vintage Glass Works</title>
                <meta name="robots" content="noindex" />
            </Helmet>
            
            <div className="not-found-page">
                <div className="container text-center">
                    <h1>404</h1>
                    <h2>Page Not Found</h2>
                    <p>The page you're looking for doesn't exist or has been moved.</p>
                    <div className="not-found-links">
                        <Link to="/" className="btn-primary-custom">Go Home</Link>
                        <Link to="/#services" className="btn-secondary-custom">View Services</Link>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NotFound;